module.exports = __webpack_public_path__ + "static/sixth_user_image4-e90fddea497f1dd9034eec0204589f19.jpg";